import { isEmpty } from 'lodash';

import BackendConnector from './backendConnector';

export default class WorkflowHttpService {
    static getWorkflowSearch(params) {
        if (isEmpty(params)) {
            return new Promise(((resolve, reject) => {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject('Missing Data');
            }));
        }

        return BackendConnector.post('/workflow/search', params);
    }

    static getWorkflowItemsData(params) {
        if (isEmpty(params)) {
            return new Promise(((resolve, reject) => {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject('Missing Data');
            }));
        }

        return BackendConnector.post('/workflow/itemsData', params);
    }

    static addWorkflowEvent(workflowId, eventData) {
        return BackendConnector.post(`/workflow/${workflowId}/event`, eventData);
    }

    static isFeedbackFromEmployerExists(feedbackStatus) {
        return feedbackStatus === 'accepted';
    }

    static putEmployerWorkflowStatus(workflowId, data) {
        return BackendConnector.put(`/workflow/${workflowId}/employerStatus`, data);
    }

    static putRecruiterWorkflowStatus(workflowId, data) {
        return BackendConnector.put(`/workflow/${workflowId}/recruiterStatus`, data);
    }

    static moveWorkflowsToFullService(data) {
        return BackendConnector.post('/workflow/moveWorkflowsToFullService', data);
    }

    static rejectCandidateBulk(data) {
        return BackendConnector.post('workflow/rejectBulk', data);
    }
}
